'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M5 13h14v-2H5v2zm-2 4h14v-2H3v2zM7 7v2h14V7H7z' });

var ClearAll = function ClearAll(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

ClearAll = (0, _pure2.default)(ClearAll);
ClearAll.muiName = 'SvgIcon';

exports.default = ClearAll;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/ClearAll.js
// module id = 2254
// module chunks = 0